import React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import drawerBarStyles from '@/common/components/NavigationBar/DrawerBar.styles';
import { useToggle } from '@/common/hooks/index';
import Header from '@/common/components/NavigationBar/components/Header';
import Navigation from '@/common/components/NavigationBar/components/Navigation';
import Control from '@/common/components/NavigationBar/components/Control';

const DrawerBar = ({ className, list, admin }) => {
  const theme = useTheme();
  const [mobileMenuOpen, toggleMobileMenu] = useToggle(false);
  const isMobileLayout = useMediaQuery(theme.breakpoints.down('laptop'));

  const handleOpenMobileMenu = () => {
    if (!mobileMenuOpen) {
      toggleMobileMenu();
    }
  };

  const handleCloseMobileMenu = () => {
    if (mobileMenuOpen) {
      toggleMobileMenu();
    }
  };

  const renderDrawerBody = ({ mobile = false } = {}) => (
    <Box sx={drawerBarStyles.drawerContent}>
      {mobile ? (
        <IconButton
          onClick={handleCloseMobileMenu}
          size="small"
          sx={{ width: 'fit-content', m: 4 }}
        >
          <CloseIcon />
        </IconButton>
      ) : (
        <Header mobile={false} admin={admin} />
      )}
      <Navigation
        list={list}
        isMobileLayout={isMobileLayout}
        onCloseMobileMenu={handleCloseMobileMenu}
      />
      <Box sx={drawerBarStyles.footer}>
        <Control admin={admin} />
      </Box>
    </Box>
  );

  return (
    <Box className={className} sx={drawerBarStyles.container}>
      {isMobileLayout ? (
        <>
          <Header mobile onMenuClick={handleOpenMobileMenu} />
          <Drawer
            variant="temporary"
            open={mobileMenuOpen}
            onClose={handleCloseMobileMenu}
            ModalProps={{ keepMounted: true }}
            sx={drawerBarStyles.mobileDrawer}
          >
            {renderDrawerBody({ mobile: true })}
          </Drawer>
        </>
      ) : (
        <Drawer variant="permanent" open sx={drawerBarStyles.desktopDrawer}>
          {renderDrawerBody()}
        </Drawer>
      )}
    </Box>
  );
};

export default DrawerBar;
